import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { ErrorMessage, SelfBookingAppointmentAthleteHasHasValidCredit, UrlParams } from 'types';
import { client } from 'utils/api-client';

interface IUseAthleteHasValidCreditForSelfBookableAppointmentType {
  appointmentTypeId?: string | null;
  startDate?: string;
  enabled?: boolean;
}

export default function useSelfBookingAppointmentAthleteHasValidCredit({
  appointmentTypeId,
  startDate,
  enabled = true,
}: IUseAthleteHasValidCreditForSelfBookableAppointmentType): UseQueryResult<
  AxiosResponse<SelfBookingAppointmentAthleteHasHasValidCredit>,
  AxiosError<ErrorMessage>
> {
  const queryFn = (): Promise<AxiosResponse<SelfBookingAppointmentAthleteHasHasValidCredit>> => {
    const params: UrlParams = {};

    if (startDate) {
      params.start_date = startDate;
    }

    return client.get(
      `appointment-self-booking/${appointmentTypeId}/athlete-has-valid-credit-dispensation/`,
      {
        params,
      },
    );
  };

  return useQuery(
    ['appointment-type-self-booking-athlete-has-valid-credit-dispensation', appointmentTypeId, startDate],
    queryFn,
    {
      enabled: enabled && !!appointmentTypeId && !!startDate,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  );
}
